<app-header>
  <app-contract-page-nav headerLeft current="sell" [lastUpdate]="lastUpdate" [refreshing]="refreshing"
    [refreshTick]="refreshTick" (refresh)="loadContracts()"></app-contract-page-nav>

  <button mat-icon-button (click)="drawer.toggle()" [matTooltip]="drawer.opened ? 'Hide bot accounts' : 'Show bot accounts'">
    <mat-icon>{{ drawer.opened ? 'menu_open' : 'menu' }}</mat-icon>
  </button>

  @if (isAdmin) {
  <app-contract-balance variant="compact"></app-contract-balance>
  }

  @if (isAdmin) {
  <button mat-icon-button [matMenuTriggerFor]="viewMenu" matTooltip="View options">
    <mat-icon>tune</mat-icon>
  </button>
  <mat-menu #viewMenu="matMenu">
    <button mat-menu-item (click)="setViewMode('normal')">
      <mat-icon>{{ viewMode === 'normal' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
      <span>My orders</span>
    </button>
    <button mat-menu-item (click)="setViewMode('admin')">
      <mat-icon>{{ viewMode === 'admin' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
      <span>All orders (admin view)</span>
    </button>
    @if (useAdminView) {
    <button mat-menu-item (click)="openAccountDialog()">
      <mat-icon>manage_accounts</mat-icon>
      <span>Contract accounts</span>
    </button>
    }
  </mat-menu>
  }

  @if (canEdit) {
  <button mat-flat-button class="compact-btn" (click)="openCreateContractDialog()" matTooltip="New order"
    matTooltipPosition="below">
    <mat-icon>add</mat-icon>
    <span class="btn-label">New Order</span>
  </button>
  }
</app-header>

<mat-drawer-container class="main-container" autosize>
  <mat-drawer #drawer class="sidenav-left" [mode]="isMobile ? 'over' : 'side'" position="start">
    <app-account-list [type]="'contract'"></app-account-list>
  </mat-drawer>

  <div class="main-content">
    <main class="page list-compact">
      @if (stats) {
      <div class="status-chips" role="group" aria-label="Filter by status">
        <button type="button" class="status-chip status-all" [class.active]="!filterStatus"
          [attr.aria-pressed]="!filterStatus" (click)="setStatusFilter('')">
          All<b>{{ stats.total_contracts }}</b>
        </button>
        @for (s of statusOptions; track s) {
        @if (stats.status_counts[s] || filterStatus === s) {
        <button type="button" class="status-chip" [ngClass]="getStatusClass(s)" [class.active]="filterStatus === s"
          [attr.aria-pressed]="filterStatus === s" (click)="setStatusFilter(s)">
          {{ s }}<b>{{ stats.status_counts[s] ?? 0 }}</b>
        </button>
        }
        }
      </div>
      }

      <div class="list-toolbar">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-wide field-search">
          <mat-label>Search</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [(ngModel)]="filterSearch" (ngModelChange)="onSearchChange()" placeholder="Name, note, email or ID" />
        </mat-form-field>

        <button mat-stroked-button class="filter-toggle" [class.has-filters]="hasExtraFilters"
          (click)="filtersOpen = !filtersOpen" [attr.aria-expanded]="filtersOpen">
          <mat-icon>{{ filtersOpen ? 'expand_less' : 'tune' }}</mat-icon>
          Filters
        </button>

        <div class="filter-extra" [class.open]="filtersOpen">
          <mat-button-toggle-group [(ngModel)]="filterArchived" (ngModelChange)="onFilterChange()" aria-label="Archived">
            <mat-button-toggle value="false">Active</mat-button-toggle>
            <mat-button-toggle value="">All</mat-button-toggle>
            <mat-button-toggle value="true">Archived</mat-button-toggle>
          </mat-button-toggle-group>

          <mat-button-toggle-group [(ngModel)]="filterInPool" (ngModelChange)="onFilterChange()" aria-label="Pool">
            <mat-button-toggle value="">Any pool</mat-button-toggle>
            <mat-button-toggle value="true">In pool</mat-button-toggle>
            <mat-button-toggle value="false">Not in pool</mat-button-toggle>
          </mat-button-toggle-group>

          <mat-button-toggle-group [(ngModel)]="filterQuickSelling" (ngModelChange)="onFilterChange()" aria-label="Quick sell">
            <mat-button-toggle value="">Any</mat-button-toggle>
            <mat-button-toggle value="true">Quick selling</mat-button-toggle>
            <mat-button-toggle value="false">Not quick selling</mat-button-toggle>
          </mat-button-toggle-group>

          @if (useAdminView) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Owner role</mat-label>
            <mat-select [(ngModel)]="filterOwnerRole" (ngModelChange)="onFilterChange()">
              <mat-option value="">All</mat-option>
              @for (r of roleOptions; track r) {
              <mat-option [value]="r">{{ r }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-wide">
            <mat-label>Created between</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate [(ngModel)]="filterStartDate" (ngModelChange)="onDateRangeChange()" placeholder="Start">
              <input matEndDate [(ngModel)]="filterEndDate" (ngModelChange)="onDateRangeChange()" placeholder="End">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker></mat-date-range-picker>
          </mat-form-field>

          @if (hasActiveFilters) {
          <button mat-button (click)="clearFilters()">
            <mat-icon>filter_alt_off</mat-icon>
            Clear filters
          </button>
          }
        </div>

        <span class="spacer"></span>

        @if (useAdminView) {
        <button type="button" class="pill status-stopped view-pill" (click)="setViewMode('normal')"
          matTooltip="Showing every admin's orders. Click to go back to your own.">
          Admin view <mat-icon>close</mat-icon>
        </button>
        }
      </div>

      @if (searchError || dateRangeError) {
      <div class="filter-errors">
        @if (searchError) {
        <div class="filter-error"><mat-icon>error_outline</mat-icon>{{ searchError }}</div>
        }
        @if (dateRangeError) {
        <div class="filter-error"><mat-icon>error_outline</mat-icon>{{ dateRangeError }}</div>
        }
      </div>
      }

      @if (stats) {
      <div class="summary-strip">
        <div class="metric">
          <span class="metric-label">Target</span>
          <span class="metric-value">{{ formatCoins(stats.total_target) }}</span>
        </div>
        <div class="metric">
          <span class="metric-label">Received</span>
          <span class="metric-value">{{ formatCoins(stats.total_received) }}</span>
        </div>
        <div class="metric">
          <span class="metric-label">Remaining (open)</span>
          <span class="metric-value">{{ formatCoins(stats.left_target.total) }}</span>
        </div>
        <div class="metric metric-progress"
          matTooltip="Combined coin flow vs. total target, across all matched orders">
          <span class="metric-label">{{ statsPercentReached }}% of target</span>
          <mat-progress-bar mode="determinate" [value]="statsPercentReached"></mat-progress-bar>
        </div>
      </div>
      }

      @if (canEdit && selectedIds.size > 0) {
      <div class="bulk-bar">
        <mat-icon>checklist</mat-icon>
        <span><b>{{ selectedIds.size }}</b> selected</span>
        <span class="spacer"></span>
        <button mat-stroked-button (click)="bulkSetArchived(true)">
          <mat-icon>archive</mat-icon>
          Archive
        </button>
        <button mat-stroked-button (click)="bulkSetArchived(false)">
          <mat-icon>unarchive</mat-icon>
          Unarchive
        </button>
        <button mat-stroked-button [disabled]="!selectedEligibleForQuickSell" (click)="bulkQuickSellLeftovers()"
          matTooltip="Only Canceled or Failed orders not already quick selling can quick sell leftovers">
          <mat-icon>sell</mat-icon>
          Quick Sell Leftovers
        </button>
        <button mat-button (click)="selectedIds.clear()">Clear</button>
      </div>
      }

      <div class="table-card">
      @if (loading) {
      <div class="table-state">
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
        Loading orders…
      </div>
      } @else {
      <div class="table-scroll">
        <table mat-table [dataSource]="contracts" [trackBy]="trackByContractId">

          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox [checked]="allSelected" [indeterminate]="someSelected" (change)="toggleSelectAll()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let c">
              <mat-checkbox [checked]="selectedIds.has(c.id)" (change)="toggleSelect(c.id)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let c">
              @if (c.in_pool) {
              <span class="in-pool-icon" matTooltip="In Pool">P</span>
              }
              @if (c.priority) {
              <mat-icon class="priority-icon" matTooltip="Priority: pool cards are bought first">star</mat-icon>
              }
              <a class="contract-name-btn" (click)="openContractInfoDialog(c)">
                {{ c.name || shortId(c.id) }}
              </a>
              @if (c.name) {
              <button type="button" class="copy-name-btn" (click)="copyName(c)" matTooltip="Copy name" aria-label="Copy name">
                <mat-icon>content_copy</mat-icon>
              </button>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef>Seller</th>
            <td mat-cell *matCellDef="let c">
              <div class="owner-cell">
                <span class="owner-username">{{ c.seller_username }}</span>
                @if (c.seller_roles?.length) {
                <span class="owner-roles" [matTooltip]="c.seller_roles.join(', ')">{{ c.seller_roles.join(', ')
                  }}</span>
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="note">
            <th mat-header-cell *matHeaderCellDef>Note</th>
            <td mat-cell *matCellDef="let c" class="note-cell">
              @if (c.note) {
              <span class="note-text" [matTooltip]="c.note" matTooltipShowDelay="300">{{ c.note }}</span>
              } @else {
              <span class="empty-value">—</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="target_coins">
            <th mat-header-cell *matHeaderCellDef>Target</th>
            <td mat-cell *matCellDef="let c">{{ formatCoins(c.target_coins) }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
              Status
              <div class="sub-header">process / payment</div>
            </th>
            <td mat-cell *matCellDef="let c">
              <div class="status-container">
                <span [class]="'status-badge ' + getStatusClass(c.status)"
                  [matTooltip]="c.failed_reason ? 'Fail reason: ' + c.failed_reason : c.stopped_at ? 'Stopped at ' + formatDateAndTime(c.stopped_at) : undefined">{{ c.status }}</span>
                <span [class]="'payment-badge ' + getPaymentClass(c.payment_status)" [matTooltip]="c.payment_status">
                  <mat-icon class="payment-icon">{{ getPaymentIcon(c.payment_status) }}</mat-icon>
                </span>
                @if (c.quick_sell_started_at) {
                <span class="quick-sell-badge" [matTooltip]="'Quick selling leftovers since ' + formatDateAndTime(c.quick_sell_started_at)">
                  <mat-icon class="quick-sell-icon">sell</mat-icon>
                  Quick selling
                </span>
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="coins">
            <th mat-header-cell *matHeaderCellDef>
              Coin
              <div class="sub-header">Send / Receive</div>
            </th>
            <td mat-cell *matCellDef="let c">
              @if (c.status !== 'Pending') {
              {{ formatCoins(c.estimated_sent_coins) }} / {{ formatCoins(c.estimated_received_coins) }}
              } @else {
              <span class="empty-value">—</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="cards_summary">
            <th mat-header-cell *matHeaderCellDef>
              Cards
              <div class="sub-header">Total / Listed / Sold / Expired / Quick Sold / Left Behind</div>
            </th>
            <td mat-cell *matCellDef="let c">
              @if (c.cards_summary) {
              <div class="counter-row">
                <span class="counter" [class.is-zero]="!c.cards_summary.total" matTooltip="Total">{{ c.cards_summary.total }}</span>
                <span class="counter counter--listed" [class.is-zero]="!c.cards_summary.listed" matTooltip="Listed">{{ c.cards_summary.listed }}</span>
                <span class="counter counter--sold" [class.is-zero]="!c.cards_summary.sold" matTooltip="Sold">{{ c.cards_summary.sold }}</span>
                <span class="counter counter--expired" [class.is-zero]="!c.cards_summary.expired" matTooltip="Expired">{{ c.cards_summary.expired }}</span>
                @if (c.cards_summary.quick_sold) {
                <span class="counter counter--quick-sold" [class.is-zero]="!c.cards_summary.quick_sold"
                  [matTooltip]="'Quick Sold (Loss: ' + formatCoins(c.cards_summary.quick_sold_loss) + ')'">{{ c.cards_summary.quick_sold }}</span>
                }
                @if (c.cards_summary.left_behind) {
                <span class="counter counter--left-behind" [class.is-zero]="!c.cards_summary.left_behind" matTooltip="Left Behind">{{ c.cards_summary.left_behind }}</span>
                }
              </div>
              } @else {
              <span class="empty-value">—</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="fee">
            <th mat-header-cell *matHeaderCellDef>Fee</th>
            <td mat-cell *matCellDef="let c">{{ formatToman(c.fee) }}</td>
          </ng-container>

          <ng-container matColumnDef="total_price">
            <th mat-header-cell *matHeaderCellDef>Total Price</th>
            <td mat-cell *matCellDef="let c">{{ formatToman(c.fee_amount) }}</td>
          </ng-container>

          <ng-container matColumnDef="issue">
            <th mat-header-cell *matHeaderCellDef>Issue</th>
            <td mat-cell *matCellDef="let c">
              @if (c.current_issue) {
              <span class="issue-badge" [matTooltip]="'Resumes: ' + formatDateAndTime(c.current_issue.resume_at)">
                <mat-icon class="issue-icon">warning</mat-icon>
                {{ c.current_issue.type }}
              </span>
              } @else {
              <span class="empty-value">—</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="timing">
            <th mat-header-cell *matHeaderCellDef>
              Timing
              <div class="sub-header">Start / Finish</div>
            </th>
            <td mat-cell *matCellDef="let c">
              <div class="time">
                {{ formatDateAndTime(c.started_at) }}
              </div>
              <div class="time">
                @if (c.finished_at) {
                {{ formatDateAndTime(c.finished_at) }}
                } @else {
                <span class="empty-value">—</span>
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let c">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                @if (canEdit && c.status !== 'Done' && c.status !== 'Outsourcing') {
                <button mat-menu-item (click)="openPatchDialog(c)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit</span>
                </button>
                }

                <button mat-menu-item (click)="shareSellerLink(c)">
                  <mat-icon>share</mat-icon>
                  <span>Seller Link</span>
                </button>

                <button mat-menu-item (click)="shareBuyerLink(c)">
                  <mat-icon>share</mat-icon>
                  <span>Buyer Link</span>
                </button>

                <button mat-menu-item (click)="viewCards(c)">
                  <mat-icon>style</mat-icon>
                  <span>View Cards</span>
                </button>

                <button mat-menu-item (click)="viewLogs(c)">
                  <mat-icon>terminal</mat-icon>
                  <span>View Logs</span>
                </button>

                @if (canQuickSellLeftovers(c)) {
                <button mat-menu-item (click)="quickSellLeftovers(c)">
                  <mat-icon>sell</mat-icon>
                  <span>Quick Sell Leftovers</span>
                </button>
                }

                @if (isAdmin && canEdit) {
                <button mat-menu-item (click)="openBillingDialog(c)">
                  <mat-icon>payments</mat-icon>
                  <span>Edit Billing</span>
                </button>
                }
                @if (isAdmin && canEdit) {
                <button mat-menu-item (click)="setPriority(c, !c.priority)">
                  <mat-icon>{{ c.priority ? 'star_border' : 'star' }}</mat-icon>
                  <span>{{ c.priority ? 'Remove Priority' : 'Prioritize' }}</span>
                </button>
                }
                @if (isAdmin) {
                <button mat-menu-item (click)="openOutsourcingHandoffDialog(c)">
                  <mat-icon>sync_alt</mat-icon>
                  <span>Outsourcing Handoff</span>
                </button>
                }

                @if (isAdmin && canEdit && c.status == 'Failed') {
                <button mat-menu-item (click)="openEditDialog(c)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit Login Info</span>
                </button>
                }

                @if (canCancel(c)) {
                <button mat-menu-item (click)="cancel(c)">
                  <mat-icon>cancel</mat-icon>
                  <span>Cancel</span>
                </button>
                }
                @if (canStop(c)) {
                <button mat-menu-item (click)="stop(c)">
                  <mat-icon>pause</mat-icon>
                  <span>Stop</span>
                </button>
                }
                @if (canResume(c)) {
                <button mat-menu-item (click)="resume(c)">
                  <mat-icon>play_arrow</mat-icon>
                  <span>Resume</span>
                </button>
                }

                @if (canEdit) {
                @if (!c.archived) {
                <button mat-menu-item (click)="setArchived(c, true)">
                  <mat-icon>archive</mat-icon>
                  <span>Archive</span>
                </button>
                } @else {
                <button mat-menu-item (click)="setArchived(c, false)">
                  <mat-icon>unarchive</mat-icon>
                  <span>Unarchive</span>
                </button>
                }
                }
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <div class="contract-cards">
        @for (c of contracts; track c.id) {
        <div class="contract-card">
          <div class="card-top">
            <div class="card-select-name">
              <mat-checkbox [checked]="selectedIds.has(c.id)" (change)="toggleSelect(c.id)"></mat-checkbox>
              @if (c.in_pool) {
              <span class="in-pool-icon" matTooltip="In Pool">P</span>
              }
              @if (c.priority) {
              <mat-icon class="priority-icon" matTooltip="Priority: pool cards are bought first">star</mat-icon>
              }
              <a class="contract-name-btn" (click)="openContractInfoDialog(c)">{{ c.name || shortId(c.id) }}</a>
              @if (c.name) {
              <button type="button" class="copy-name-btn" (click)="copyName(c)" matTooltip="Copy name" aria-label="Copy name">
                <mat-icon>content_copy</mat-icon>
              </button>
              }
            </div>

            <button mat-icon-button [matMenuTriggerFor]="cardMenu">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #cardMenu="matMenu">
              @if (canEdit && c.status !== 'Done' && c.status !== 'Outsourcing') {
              <button mat-menu-item (click)="openPatchDialog(c)">
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              }

              <button mat-menu-item (click)="shareSellerLink(c)">
                <mat-icon>share</mat-icon>
                <span>Seller Link</span>
              </button>

              <button mat-menu-item (click)="shareBuyerLink(c)">
                <mat-icon>share</mat-icon>
                <span>Buyer Link</span>
              </button>

              <button mat-menu-item (click)="viewCards(c)">
                <mat-icon>style</mat-icon>
                <span>View Cards</span>
              </button>

              <button mat-menu-item (click)="viewLogs(c)">
                <mat-icon>terminal</mat-icon>
                <span>View Logs</span>
              </button>

              @if (canQuickSellLeftovers(c)) {
              <button mat-menu-item (click)="quickSellLeftovers(c)">
                <mat-icon>sell</mat-icon>
                <span>Quick Sell Leftovers</span>
              </button>
              }

              @if (isAdmin && canEdit) {
              <button mat-menu-item (click)="openBillingDialog(c)">
                <mat-icon>payments</mat-icon>
                <span>Edit Billing</span>
              </button>
              }
              @if (isAdmin && canEdit) {
              <button mat-menu-item (click)="setPriority(c, !c.priority)">
                <mat-icon>{{ c.priority ? 'star_border' : 'star' }}</mat-icon>
                <span>{{ c.priority ? 'Remove Priority' : 'Prioritize' }}</span>
              </button>
              }
              @if (isAdmin) {
              <button mat-menu-item (click)="openOutsourcingHandoffDialog(c)">
                <mat-icon>sync_alt</mat-icon>
                <span>Outsourcing Handoff</span>
              </button>
              }

              @if (canCancel(c)) {
              <button mat-menu-item (click)="cancel(c)">
                <mat-icon>cancel</mat-icon>
                <span>Cancel</span>
              </button>
              }
              @if (canStop(c)) {
              <button mat-menu-item (click)="stop(c)">
                <mat-icon>pause</mat-icon>
                <span>Stop</span>
              </button>
              }
              @if (canResume(c)) {
              <button mat-menu-item (click)="resume(c)">
                <mat-icon>play_arrow</mat-icon>
                <span>Resume</span>
              </button>
              }

              @if (canEdit) {
              @if (!c.archived) {
              <button mat-menu-item (click)="setArchived(c, true)">
                <mat-icon>archive</mat-icon>
                <span>Archive</span>
              </button>
              } @else {
              <button mat-menu-item (click)="setArchived(c, false)">
                <mat-icon>unarchive</mat-icon>
                <span>Unarchive</span>
              </button>
              }
              }
            </mat-menu>
          </div>

          @if (useAdminView) {
          <div class="owner-cell">
            <span class="owner-username">{{ c.seller_username }}</span>
            @if (c.seller_roles?.length) {
            <span class="owner-roles">{{ c.seller_roles ? c.seller_roles.join(', ') : 'no role' }}</span>
            }
          </div>
          }

          <div class="card-badges status-container">
            <span [class]="'status-badge ' + getStatusClass(c.status)"
              [matTooltip]="c.failed_reason ? 'Fail reason: ' + c.failed_reason : c.stopped_at ? 'Stopped at ' + formatDateAndTime(c.stopped_at) : undefined">{{ c.status }}</span>
            <span [class]="'payment-badge ' + getPaymentClass(c.payment_status)" [matTooltip]="c.payment_status">
              <mat-icon class="payment-icon">{{ getPaymentIcon(c.payment_status) }}</mat-icon>
            </span>
            @if (c.quick_sell_started_at) {
            <span class="quick-sell-badge" [matTooltip]="'Quick selling leftovers since ' + formatDateAndTime(c.quick_sell_started_at)">
              <mat-icon class="quick-sell-icon">sell</mat-icon>
              Quick selling
            </span>
            }
            @if (c.current_issue) {
            <span class="issue-badge" [matTooltip]="'Resumes: ' + formatDateAndTime(c.current_issue.resume_at)">
              <mat-icon class="issue-icon">warning</mat-icon>
              {{ c.current_issue.type }}
            </span>
            }
          </div>

          @if (c.note) {
          <div class="card-note">{{ c.note }}</div>
          }

          <div class="card-meta">
            <div>
              <span class="meta-label">Target</span>
              {{ formatCoins(c.target_coins) }}
            </div>
            <div>
              <span class="meta-label">Send / Receive</span>
              @if (c.status !== 'Pending') {
              {{ formatCoins(c.estimated_sent_coins) }} / {{ formatCoins(c.estimated_received_coins) }}
              } @else {
              <span class="empty-value">—</span>
              }
            </div>
            @if (useAdminView) {
            <div>
              <span class="meta-label">Fee</span>
              {{ formatToman(c.fee) }}
            </div>
            <div>
              <span class="meta-label">Total Price</span>
              {{ formatToman(c.fee_amount) }}
            </div>
            }
            <div>
              <span class="meta-label">Started</span>
              {{ formatDateAndTime(c.started_at) }}
            </div>
            <div>
              <span class="meta-label">Finished</span>
              @if (c.finished_at) {
              {{ formatDateAndTime(c.finished_at) }}
              } @else {
              <span class="empty-value">—</span>
              }
            </div>
          </div>

          @if (c.cards_summary) {
          <div class="counter-row">
            <span class="counter" [class.is-zero]="!c.cards_summary.total" matTooltip="Total">{{ c.cards_summary.total }}</span>
            <span class="counter counter--listed" [class.is-zero]="!c.cards_summary.listed" matTooltip="Listed">{{ c.cards_summary.listed }}</span>
            <span class="counter counter--sold" [class.is-zero]="!c.cards_summary.sold" matTooltip="Sold">{{ c.cards_summary.sold }}</span>
            <span class="counter counter--expired" [class.is-zero]="!c.cards_summary.expired" matTooltip="Expired">{{ c.cards_summary.expired }}</span>
            @if (c.cards_summary.quick_sold) {
            <span class="counter counter--quick-sold" [class.is-zero]="!c.cards_summary.quick_sold"
              [matTooltip]="'Quick Sold (Loss: ' + formatCoins(c.cards_summary.quick_sold_loss) + ')'">{{ c.cards_summary.quick_sold }}</span>
            }
            @if (c.cards_summary.left_behind) {
            <span class="counter counter--left-behind" [class.is-zero]="!c.cards_summary.left_behind" matTooltip="Left Behind">{{ c.cards_summary.left_behind }}</span>
            }
          </div>
          }
        </div>
        }
      </div>

      @if (contracts.length === 0) {
      <div class="table-state">
        <mat-icon>inbox</mat-icon>
        No orders match these filters.
      </div>
      }

      <mat-paginator [length]="total" [pageIndex]="pageIndex" [pageSize]="pageSize"
        [pageSizeOptions]="[20, 50, 100]" (page)="onPage($event)">
      </mat-paginator>
      }
      </div>
    </main>
  </div>
</mat-drawer-container>